/**
 * Array of objects for the projects slider. Each object includes an id, url for the image, and an alt description.
 * @type {[[{alt: string, id: number, url: string}, {alt: string, id: number, url: string}, {alt: string, id: number, url: string}, {technologies: string, description: string, url: string}], [{alt: string, id: number, url: string}, {alt: string, id: number, url: string}, {alt: string, id: number, url: string}, {technologies: string, description: string, url: string}], [{alt: string, id: number, url: string}, {alt: string, id: number, url: string}, {alt: string, id: number, url: string}, {technologies: string, description: string, url: string}]]}
 */
export const projectInfoArray = [
	[
		{
			id: 1,
			url: "https://res.cloudinary.com/bcantello/image/upload/v1633044873/Screen_Shot_2021-09-30_at_4.31.52_PM_qwdfq7.png",
			alt: "CartRover Image 1",
		},
		{
			id: 2,
			url: "https://res.cloudinary.com/bcantello/image/upload/v1633044870/Screen_Shot_2021-09-30_at_4.33.04_PM_q0sjpp.png",
			alt: "CartRover Image 2",
		},
		{
			id: 3,
			url: "https://res.cloudinary.com/bcantello/image/upload/v1633044872/Screen_Shot_2021-09-30_at_4.33.37_PM_zp43vq.png",
			alt: "CartRover Image 3",
		},
		{
			title: "CartRover",
			description: "The CartRover team is dedicated to making efficient, simple, and cost-effective ecommerce " +
				"integrations. We focus on creating integrated solutions for order management. Through optimization " +
				"and automation, we make otherwise separate systems work seamlessly together.",
			url: "https://www.cartrover.com/",
			gitRepo: null,
			technologies: "PHP SQL XML GraphQL",
		}
	],
	[
		{
			id: 1,
			url: "https://res.cloudinary.com/bcantello/image/upload/v1633045569/Screen_Shot_2021-09-30_at_4.42.44_PM_tgnzse.png",
			alt: "Peoples Voice Project Image 1",
		},
		{
			id: 2,
			url: "https://res.cloudinary.com/bcantello/image/upload/v1633045569/Screen_Shot_2021-09-30_at_4.45.28_PM_xexixl.png",
			alt: "Peoples Voice Project Image 2",
		},
		{
			id: 3,
			url: "https://res.cloudinary.com/bcantello/image/upload/v1633045569/Screen_Shot_2021-09-30_at_4.44.20_PM_e7inec.png",
			alt: "Peoples Voice Project Image 3",
		},
		{
			title: "The Peoples Voice Project",
			description: "The People's Voice Project exists to amplify the voices of each and every person through " +
				"direct access to the elected officials who represent them. It provides a central location where " +
				"users can search for and contact government representatives, discover upcoming local and national " +
				"elections, and find polling locations.",
			url: "https://www.peoplesvoiceproject.com/",
			gitRepo: "https://github.com/bcantello/peoples_voice_project",
			technologies: "ReactJS HTML CSS",
		}
	],
	[
		{
			id: 1,
			url: "https://res.cloudinary.com/bcantello/image/upload/v1633044628/Screen_Shot_2021-09-30_at_3.53.02_PM_nrnxq1.png",
			alt: "Spacelab Image 1",
		},
		{
			id: 2,
			url: "https://res.cloudinary.com/bcantello/image/upload/v1633044608/Screen_Shot_2021-09-30_at_3.55.19_PM_cw80cc.png",
			alt: "Spacelab Image 2",
		},
		{
			id: 3,
			url: "https://res.cloudinary.com/bcantello/image/upload/v1633044597/Screen_Shot_2021-09-30_at_3.54.20_PM_yfxwlj.png",
			alt: "Spacelab Image 3",
		},
		{
			title: "Spacelab",
			description: "SpaceLab is a project with the goal to explore NASA/CalTech data from the TESS, Kepler and " +
				"K2 Missions using various degrees of Machine Learning and Deep Neural Networks in the pursuit of " +
				"Earth-Like planets around nearby stars in the Milky Way Galaxy.",
			url: "http://spacelab.space/",
			gitRepo: "https://github.com/bcantello/spacelab-react",
			technologies: "ReactJS HTML SCSS Bootstrap",
		}
	]
];
